*,
*:before,
*:after {
  box-sizing: border-box;
}
body {
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 16px;
  line-height: 1.5;
  color: #555;
  background-color: #eee;
}
a {
  color: #dd0441;
}
a:hover,
a:focus,
a:active {
  color: #8a0027;
}
.App {
  margin: 40px auto;
  width: 480px;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  background-color: #fff;
}



/** WEBPACK FOOTER **
 ** ./~/less-loader!./src/App.less
 **/